import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import $ from 'jquery';

export default function useLegacyScripts() {
    const location = useLocation();

    useEffect(() => {
        const $window = $(window);
        const eventNamespace = '.legacy_scripts';

        // Helper: Safe Event Binding
        const bind = (selector, event, handler) => {
            const $el = $(selector);
            if ($el.length) {
                $el.off(event).on(event, handler);
            }
        };

        // 1. Page Loader - Removed
        $('.side-menu').removeClass('opacity-0');

        // 2. Tooltips
        const initTooltips = () => {
            if ($.fn.tooltip) {
                $('[data-toggle="tooltip"]').tooltip();
            }
            if ($.fn.tooltipster) {
                let $tooltip = $('.tooltip');
                if ($tooltip.length) {
                    $tooltip.tooltipster({
                        plugins: ['follower'],
                        anchor: 'bottom-right',
                        offset: [0, 0],
                        animation: 'fade',
                        content: 'Click Here To Close or Press ESC!',
                        delay: 20,
                        theme: 'tooltipster-light',
                        repositionOnScroll: true
                    });
                }
            }
        };

        // 3. Contact Form
        const initContactForm = () => {
            bind("#submit_btn", 'click', function () {
                let userName = $('input[name=userName]').val();
                let userEmail = $('input[name=email]').val();
                let companyName = $('input[name=companyName]').val();

                let postData, output;
                let proceed = true;
                if (userName === "") proceed = false;
                if (userEmail === "") proceed = false;
                if (companyName === "") proceed = false;

                if (proceed) {
                    postData = { 'userName': userName, 'userEmail': userEmail, 'userMessage': companyName };
                    $.post('contact.php', postData, function (response) {
                        if (response.type === 'error') {
                            output = '<div class="alert-danger" style="padding:10px; margin-bottom:25px;">' + response.text + '</div>';
                        } else {
                            output = '<div class="alert-success" style="padding:10px; margin-bottom:25px;">' + response.text + '</div>';
                            $('.getin_form input').val('');
                            $('.getin_form textarea').val('');
                        }
                        $("#result").slideUp("fast").html(output).slideDown();
                    }, 'json');
                } else {
                    output = '<div class="alert-danger" style="padding:10px; margin-bottom:25px;">Please provide the missing fields.</div>';
                    $("#result").slideUp("fast").html(output).slideDown();
                }
            });
        };

        // 4. Rating Stars
        const initRatings = () => {
            const fadeInStar = () => {
                let starItem = $('#rattingIcon .fa-star.fas');
                starItem.addClass('scale-star');
                setTimeout(() => starItem.removeClass('scale-star'), 180);
            };
            const ratingText = $('#ratingText');
            const fadeInStarText = (n) => {
                ratingText.addClass('scale-price');
                setTimeout(() => {
                    ratingText.removeClass('scale-price');
                    const texts = ['Poor!', 'Average!', 'Good!', 'Very Good!', 'Excellent!'];
                    if (texts[n]) ratingText.text(texts[n]);
                }, 180);
            };

            bind("#rattingIcon .fa-star", 'click', function () {
                let iconIndex = $(this).index();
                $(this).addClass("fas").removeClass("far");
                $(this).prevAll().addClass("fas").removeClass("far");
                $(this).nextAll().addClass("far").removeClass("fas");
                fadeInStar();
                fadeInStarText(iconIndex);
            });
        };

        // 5. Tabs to Accordion
        const initTabs = () => {
            const tabWrap = $(".tab-to-accordion");
            if (!tabWrap.length) return;

            // Cleanup old tab listeners explicitly
            $window.off("resize.tabs orientationchange.tabs");

            let isAccordionMode = true;
            const animSpeed = 500;
            const tabContainer = tabWrap.find(".tab-container");
            const tabItem = tabContainer.children("div[id]");
            const tabsetList = tabWrap.find(".tabset-list");
            const tabsetLi = tabsetList.find("li");
            const tabsetItem = tabsetList.find("a");
            const activeId = tabsetList.find(".active").children().attr("href");

            const accordionMode = () => {
                const liWidth = Math.round(tabsetLi.outerWidth());
                const liCount = tabsetLi.length;
                const allLiWidth = liWidth * liCount;
                const tabsetListWidth = tabsetList.outerWidth();
                if (tabsetListWidth <= allLiWidth) {
                    isAccordionMode = true;
                    tabWrap.addClass("accordion-mod");
                } else {
                    isAccordionMode = false;
                    tabWrap.removeClass("accordion-mod");
                }
            };

            const tabsToggle = () => {
                tabItem.hide();
                $(activeId).show();
                bind(tabWrap, "click", 'a[href^="#tab"]', function (e) {
                    e.preventDefault();
                    const $this = $(this);
                    const activeId = $this.attr("href");
                    const activeTabSlide = $(activeId);
                    const activeOpener = tabWrap.find('a[href="' + activeId + '"]');
                    $('a[href^="#tab"]').parent().removeClass("active");
                    activeOpener.parent().addClass("active");
                    if (isAccordionMode) {
                        tabItem.stop().slideUp(animSpeed);
                        activeTabSlide.stop().slideDown(animSpeed);
                    } else {
                        tabItem.hide();
                        activeTabSlide.show();
                    }
                });
            };

            const hashToggle = () => {
                const hash = window.location.hash;
                if (!hash || $(hash).length === 0) return;
                const activeTabSlide = $(hash);
                const activeOpener = tabWrap.find('a[href="' + hash + '"]');
                $('a[href^="#tab"]').parent().removeClass("active");
                activeOpener.parent().addClass("active");
                tabItem.hide();
                activeTabSlide.show();
                $window.scrollTop(activeTabSlide.offset().top).scrollLeft(activeTabSlide.offset().left);
            };

            const cloneTabsToAccordion = () => {
                $(tabsetItem).each(function () {
                    const $this = $(this);
                    const activeClass = $this.parent().hasClass("active");
                    const listItem = $this.attr("href");
                    const listTab = $(listItem);
                    if (activeClass) listTab.show();
                    const itemContent = $this.clone();
                    const itemTab = $this.attr("href");
                    if (activeClass) {
                        itemContent.insertBefore(itemTab).wrap('<div class="accordion-item active"></div>');
                    } else {
                        itemContent.insertBefore(itemTab).wrap('<div class="accordion-item"></div>');
                    }
                });
            };

            cloneTabsToAccordion();
            accordionMode();
            tabsToggle();
            hashToggle();
            $window.on("resize.tabs orientationchange.tabs", accordionMode);
        };

        // 6. Navigation & Scroll
        const initNavigation = () => {
            // Smooth Scroll
            bind("a.pagescroll", "click", function (event) {
                event.preventDefault();
                let action = $(this.hash).offset().top;
                if ($('body').hasClass('offset-nav')) action -= 70;
                if ($(this).hasClass('scrollupto')) action -= 65;
                $("html,body").animate({ scrollTop: action }, 1200);
            });

            // Navbar Dropdown Position
            bind(".dropdown", "mouseenter", function () {
                let $elem = $(this).find('.dropdown-menu'),
                    left = $elem.offset().left,
                    width = $elem.width(),
                    docW = $(window).width();
                if ((left + width) > docW) $elem.addClass("right-show");
                else if ((left + (width * 2)) < docW) $elem.removeClass("right-show");
            });

            /* 
            // Commenting out legacy sticky logic to avoid conflict with React Header.js
            let navbar = $("nav.navbar");
            if (navbar.not('.fixed-bottom').hasClass("static-nav")) {
                bind($window, 'scroll' + eventNamespace, function () {
                    let $scroll = $window.scrollTop();
                    let $navbar = $(".static-nav");
                    let nextSection = $(".section-nav-smooth");
                    let headerHeight = $("header").outerHeight();
                    if ($scroll > 250) {
                        $navbar.addClass("fixedmenu");
                        nextSection.css("margin-top", headerHeight);
                    } else {
                        $navbar.removeClass("fixedmenu");
                        nextSection.css("margin-top", 0);
                    }
                    if ($scroll > 125) {
                        $('.header-with-topbar nav').addClass('mt-0');
                    } else {
                        $('.header-with-topbar nav').removeClass('mt-0');
                    }
                });
                if ($window.scrollTop() >= $(window).height()) {
                    $(".static-nav").addClass('fixedmenu');
                }
            }
            */

            // Side Menu Toggle
            bind(".collapsePagesSideMenu", 'click', function () {
                $(this).find('.fas').toggleClass("rotate-180");
            });
        };

        // 7. Full Screen & Resize
        const initFullScreen = () => {
            const resizebanner = () => {
                let $fullscreen = $(".full-screen");
                if ($fullscreen.length) {
                    $fullscreen.css("height", $window.height());
                    $fullscreen.css("width", $window.width());
                }
            };
            resizebanner();
            bind($window, 'resize' + eventNamespace, resizebanner);
        };

        // 8. Progress Bar
        const initProgressBar = () => {
            if ($.fn.appear && $('.progress').length) {
                $('.progress').each(function () {
                    $(this).appear(function () {
                        $(this).animate({ opacity: 1, left: "0px" }, 500);
                        let b = $(this).find(".progress-bar").attr("data-value");
                        $(this).find(".progress-bar").animate({ width: b + "%" }, 500);
                    });
                });
            }
        };

        // 9. Particles
        const initParticles = () => {
            if ($("#particles-js").length && window.particlesJS) {
                window.particlesJS('particles-js', {
                    "particles": {
                        "number": { "value": 100, "density": { "enable": true, "value_area": 800 } },
                        "color": { "value": "#ffffff" },
                        "shape": { "type": "circle", "stroke": { "width": 0, "color": "#000000" }, "polygon": { "nb_sides": 5 } },
                        "opacity": { "value": 0.5, "random": false, "anim": { "enable": false, "speed": 1, "opacity_min": 0.1, "sync": false } },
                        "size": { "value": 5, "random": true, "anim": { "enable": false, "speed": 40, "size_min": 0.1, "sync": false } },
                        "line_linked": { "enable": false, "distance": 150, "color": "#ffffff", "opacity": 0.4, "width": 1 },
                        "move": { "enable": true, "speed": 2, "direction": "none", "random": false, "straight": false, "out_mode": "bounce", "attract": { "enable": false, "rotateX": 600, "rotateY": 1200 } }
                    },
                    "interactivity": {
                        "detect_on": "canvas",
                        "events": { "onhover": { "enable": true, "mode": "grab" }, "onclick": { "enable": true, "mode": "bubble" }, "resize": true },
                        "modes": {
                            "grab": { "distance": 150, "line_linked": { "opacity": 1 } },
                            "bubble": { "distance": 150, "size": 12, "duration": 0.2, "opacity": 0.6, "speed": 10 },
                            "repulse": { "distance": 150 },
                            "push": { "particles_nb": 1 },
                            "remove": { "particles_nb": 2 }
                        }
            },
            "retina_detect": true,
        });
    }
};

        // 10. Third Party Plugins (WOW, Parallax, Fancybox, Cube, Rev)
        const initPlugins = () => {
            // WOW
            if (window.WOW) {
                let wow = new window.WOW({
                    boxClass: 'wow', animateClass: 'animated', offset: 0, mobile: false, live: true
                });
                wow.init();
            }

            // Parallax
            if ($.fn.parallaxie && $(".parallax").length) {
                if ($(window).width() > 992) {
                    $(".parallax").parallaxie({ speed: 0.55, offset: 0 });
                    $(".parallax.parallax-slow").parallaxie({ speed: 0.31 });
                }
            }

            // Fancybox
            if ($.fn.fancybox && $('[data-fancybox]').length) {
                $('[data-fancybox]').fancybox({
                    'transitionIn': 'elastic', 'transitionOut': 'elastic', 'speedIn': 600, 'speedOut': 200,
                    buttons: ['slideShow', 'fullScreen', 'thumbs', 'share', 'zoom', 'close'],
                });
            }

            // Owl Carousel
            if ($.fn.owlCarousel && $(".owl-carousel").length) {
                // Destroy to prevent double-init
                $(".owl-carousel").each(function () {
                    let $this = $(this);
                    if ($this.data('owl.carousel')) $this.trigger('destroy.owl.carousel');
                });

                // Partners
                $("#partners-slider").owlCarousel({
                    items: 5, autoplay: 1500, smartSpeed: 1500, autoplayHoverPause: true, slideBy: 1, loop: true, margin: 30, dots: false, nav: false,
                    responsive: { 1200: { items: 5 }, 991: { items: 4 }, 767: { items: 3 }, 480: { items: 2 }, 0: { items: 1 } }
                });
                // Testimonials
                $("#testimonial-slider").owlCarousel({
                    items: 1, autoplay: false, autoplayHoverPause: true, mouseDrag: false, loop: true, margin: 30, animateIn: "fadeIn", animateOut: "fadeOut", dots: false, nav: true,
                    navText: ["<i class='fas fa-angle-left'></i>", "<i class='fas fa-angle-right'></i>"],
                    responsive: { 980: { items: 1 }, 600: { items: 1 }, 320: { items: 1 } }
                });
                // ... (Other standard carousels) ...
                $("#carousel-gallery-detail").owlCarousel({
                    items: 1, autoplay: false, mouseDrag: true, loop: true, margin: 0, dots: false, nav: true,
                    responsive: { 980: { items: 1 }, 600: { items: 1 }, 320: { items: 1 } }
                });
                $("#testimonial-main-slider").owlCarousel({
                    items: 3, autoplay: 2500, autoplayHoverPause: true, loop: true, margin: 0, dots: true, nav: false,
                    responsive: { 1280: { items: 3 }, 980: { items: 3 }, 600: { items: 2 }, 320: { items: 1 } }
                });
                $("#price-slider").owlCarousel({
                    items: 3, autoplay: false, loop: false, margin: 0, padding: 0, dots: true, nav: false,
                    responsive: { 1280: { items: 3 }, 980: { items: 3 }, 600: { items: 2 }, 0: { items: 1 } }
                });
                $("#ourteam-slider").owlCarousel({
                    items: 4, margin: 0, dots: false, nav: false,
                    responsive: { 1280: { items: 4 }, 768: { items: 3 }, 520: { items: 2 }, 0: { items: 1 } }
                });
                // `#services-slider` is initialized in `src/pages/Services.js`
                // to avoid conflicting options and responsive clipping behavior.
                $("#service-detail").owlCarousel({
                    autoplay: true, autoplayTimeout: 3000, autoplayHoverPause: true, smartSpeed: 1200, loop: true, nav: false, dots: false, mouseDrag: true, touchDrag: true, margin: 15,
                    responsive: { 0: { items: 1 }, 640: { items: 2 } }
                });
            }

            // Counters
            if ($.fn.countTo && $(".counters").length) {
                $(".counters").appear(function () {
                    $(".count_nums").countTo();
                });
            }

            // CubePortfolio
            if ($.fn.cubeportfolio && $(".cbp").length) {
                // Note: CubePortfolio often needs Destroy if re-init, but it's complex. 
                // Checks for specific IDs before init
                const initCube = (selector, settings) => {
                    if ($(selector).length) {
                        $(selector).cubeportfolio(settings);
                    }
                };

                initCube("#blog-measonry", {
                    layoutMode: 'grid', defaultFilter: '*', animationType: "rotateSides", gapHorizontal: 30, gapVertical: 30, gridAdjustment: "responsive",
                    mediaQueries: [{ width: 1500, cols: 3 }, { width: 1100, cols: 3 }, { width: 992, cols: 3 }, { width: 768, cols: 3 }, { width: 480, cols: 1 }, { width: 320, cols: 1 }]
                });
                initCube("#services-measonry", {
                    layoutMode: 'grid', defaultFilter: '*', filters: '#services-filter', animationType: "rotateSides", gapHorizontal: 30, gapVertical: 30, gridAdjustment: "responsive",
                    mediaQueries: [{ width: 1500, cols: 3 }, { width: 1100, cols: 3 }, { width: 992, cols: 3 }, { width: 768, cols: 2 }, { width: 480, cols: 1 }, { width: 320, cols: 1 }]
                });
                initCube("#testimonial-grid", {
                    layoutMode: 'grid', defaultFilter: '*', animationType: "rotateSides", gapHorizontal: 0, gapVertical: 0, gridAdjustment: "responsive",
                    mediaQueries: [{ width: 1500, cols: 4 }, { width: 1100, cols: 4 }, { width: 800, cols: 3 }, { width: 480, cols: 2 }, { width: 320, cols: 1 }]
                });
                initCube("#price-grid", {
                    layoutMode: 'grid', defaultFilter: '*', animationType: "rotateSides", gapHorizontal: 50, gapVertical: 50, gridAdjustment: "responsive",
                    mediaQueries: [{ width: 1500, cols: 3 }, { width: 1100, cols: 3 }, { width: 800, cols: 2 }, { width: 480, cols: 1 }]
                });
                initCube("#grid-mosaic", {
                    filters: "#mosaic-filter", layoutMode: 'grid', defaultFilter: "*", animationType: "rotateSides", gapHorizontal: 0, gapVertical: 0, gridAdjustment: 'responsive',
                    mediaQueries: [{ width: 1500, cols: 3 }, { width: 1100, cols: 3 }, { width: 767, cols: 2 }, { width: 480, cols: 1 }],
                    plugins: { loadMore: { element: '#js-loadMore-mosaic', action: 'click', loadItems: 4 } }
                });
            }

            // Revolution Slider
            if ($.fn.revolution) {
                if ($("#rev_main").length) {
                    $("#rev_main").show().revolution({
                        sliderType: "standard",
                        jsFileLocation: "js/revolution/",
                        sliderLayout: "fullscreen",
                        dottedOverlay: "none",
                        delay: 9000,
                        navigation: {
                            keyboardNavigation: "off", keyboard_direction: "horizontal", mouseScrollNavigation: "off", mouseScrollReverse: "default", onHoverStop: "off",
                            touch: { touchenabled: "on", swipe_threshold: 75, swipe_min_touches: 1, swipe_direction: "horizontal", drag_block_vertical: false },
                            bullets: { enable: true, hide_onmobile: true, style: "numbered", hide_onleave: false, hide_under: 767, direction: "vertical", h_align: "left", v_align: "center", h_offset: 20, v_offset: 0, space: 5, tmp: '<div class="tp-bullet-number"><span class="tp-count">{{param1}}</span><span class="tp-bullet-line"></span></div>' },
                            arrows: { style: "", enable: false }
                        },
                        viewPort: { enable: true, outof: "pause", visible_area: "80%", presize: false },
                        responsiveLevels: [1240, 1024, 778, 480], visibilityLevels: [1240, 1024, 778, 480], gridwidth: [1140, 1024, 768, 480], gridheight: [660, 650, 600, 490],
                        lazyType: "none",
                        parallax: { type: "mouse", origo: "slidercenter", speed: 2000, speedbg: 0, speedls: 0, levels: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 20, 25, 55], disable_onmobile: "on" },
                        shadow: 0, spinner: "off", stopLoop: "off", stopAfterLoops: -1, stopAtSlide: -1, shuffle: "off", autoHeight: "off", hideThumbsOnMobile: "off", hideSliderAtLimit: 0, hideCaptionAtLimit: 0, hideAllCaptionAtLimit: 0, debugMode: false,
                        fallbacks: { simplifyAll: "off", nextSlideOnWindowFocus: "off", disableFocusListener: false }
                    });
                }

                if ($("#rev_single").length) {
                    $("#rev_single").show().revolution({
                        sliderType: "hero", jsFileLocation: "js/revolution", sliderLayout: "fullscreen", scrollbarDrag: "true", dottedOverlay: "none", delay: 9000,
                        navigation: {}, responsiveLevels: [1240, 1024, 778, 480], visibilityLevels: [1240, 1024, 778, 480], gridwidth: [1170, 1024, 778, 480], gridheight: [868, 768, 960, 720],
                        lazyType: "none",
                        parallax: { type: "scroll", origo: "slidercenter", speed: 400, levels: [10, 15, 20, 25, 30, 35, 40, -10, -15, -20, -25, -30, -35, -40, -45, 55] },
                        shadow: 0, spinner: "off", autoHeight: "off", fullScreenAutoWidth: "off", fullScreenAlignForce: "off", fullScreenOffsetContainer: "", disableProgressBar: "on", hideThumbsOnMobile: "off", hideSliderAtLimit: 0, hideCaptionAtLimit: 0, hideAllCaptionAtLilmit: 0, debugMode: false,
                        fallbacks: { simplifyAll: "off", disableFocusListener: false }
                    });
                }
            }
        };

        // Initialize All
        initTooltips();
        initContactForm();
        initRatings();
        initTabs();
        initNavigation();
        initFullScreen();
        initProgressBar();
        initParticles();
        initPlugins();

        return () => {
            // Global Cleanup
            $window.off(eventNamespace);

            // Specific Cleanup
            $("#submit_btn").off('click');
            $("#rattingIcon .fa-star").off('click');
            $(".collapsePagesSideMenu").off('click');
            $(".tab-to-accordion").off('click');

            // Note: Plugin destroy is handled in init logic (e.g. Owl) or left to weak maps
        };

    }, [location.pathname]);
};


